import React from "react";

export function SettingsSection({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: React.ReactNode;
}) {
  return (
    <section className="settings_section">
      <h3 className="settings_section_title ui-text-section-title">{title}</h3>
      {description && <p className="settings_section_description ui-text-meta">{description}</p>}
      {children}
    </section>
  );
}

export type SettingsRowLayout = "split" | "stacked";

/**
 * `split` pushes the control to the far edge (selects, toggles, buttons); `stacked` places the
 * control under the label for controls too wide to sit beside it in a taskpane.
 */
export function SettingsRow({
  label,
  description,
  layout = "split",
  children,
}: {
  label: string;
  description?: string;
  layout?: SettingsRowLayout;
  children: React.ReactNode;
}) {
  return (
    <div className={`settings_row settings_row_${layout}`}>
      <div className="settings_row_text">
        <div className="settings_row_label ui-text-label">{label}</div>
        {description && <div className="settings_row_description ui-text-meta">{description}</div>}
      </div>
      <div className="settings_row_control">{children}</div>
    </div>
  );
}
